









































import {Component, Vue , Prop} from "vue-property-decorator";

@Component({})
export default class AllocationProjectItem extends Vue{
  @Prop({
    type:Object,
    default:()=>{}
  })
  caseInfo: any;

  formatDate(timestamp:any) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getCaseInfo(){
    
  }

  private onDetail(){

  }

  private onConsult(){

  }
}
